

















































































































import { Mixins, Component, Watch } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../../base/components/system/selectors/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";
import { IComboOption } from "../../../../../../../documaker/domain/format/objects";
import { ComboOptionSelector } from "../selectors";
import { IConfiguration } from "../../../../../../domain/configuration";

@Component({
  components: {
    OptionDropDownSelector,
    ComboOptionSelector,
  }
})
export default class ComboOptionEditDialog extends Mixins(DialogMixin) {
  options: IComboOption[] = [];
  pageKeys: number[] = [];
  pageKeyOptions: StandardOption<number>[] = [{ label: "なし", value: null, description: "", }];
  selectedOptions: IComboOption[] = [];

  shouldNotSelectFirst: boolean = false;
  optionText: string = "";
  optionForegroundColor: string = "#000000";
  isOptionBackgroundColorEnable: boolean = false;
  optionBackgroundColor: string = "#ffffff";
  optionScore: number = null;
  optionPageKey: number = null;
  optionCode: string = "";

  confirmed: boolean = false;

  $configuration!: IConfiguration;

  get hasOptionText(): boolean {
    return !!this.optionText;
  }

  get hasSelectedOptions(): boolean {
    return this.selectedOptions.length > 0;
  }

  get hasSingleSelectedOption(): boolean {
    return this.selectedOptions.length === 1;
  }

  get isTopSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[0]);
  }

  get isBottomSelectedOption(): boolean {
    return this.hasSelectedOptions && this.selectedOptions.some(v => v === this.options[this.options.length - 1]);
  }

  get configuration() {
    return this.$configuration.formatEditor.behavior.format.editor.object.behaviors.comboSelect;
  }

  @Watch("optionScore")
  onOptionScoreUpdated(newValue: number, oldValue: number): void {
    if (newValue === oldValue) {
      return;
    }
    if (isNaN(newValue)) {
      this.optionScore = oldValue;
    }
  }

  async show(options: IComboOption[], pageKeys: number[]): Promise<IComboOption[]> {
    return this.showModal(async () => {
      this.options = ObjectUtility.copyDeeply(options.filter(v => !v.isSelected));
      this.pageKeys = pageKeys;
      this.pageKeyOptions = this.createPageKeyStandardOptions(pageKeys);
      this.selectedOptions = [];

      this.shouldNotSelectFirst = this.options.length !== options.length;
      this.optionText = "";
      this.optionForegroundColor = "#000000";
      this.isOptionBackgroundColorEnable = false;
      this.optionBackgroundColor = "#ffffff";
      this.optionScore = null;
      this.optionPageKey = null;
      this.optionCode = "";

      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed
        ? this.shouldNotSelectFirst
          ? [this.createUnselectedFirstComboOption()].concat(this.options)
          : this.options
        : null;
    });
  }

  private createPageKeyStandardOptions(pageKeys: number[]): StandardOption<number>[] {
    return [this.createPageKeyStandardOption("なし", null)]
      .concat(pageKeys.map((v, i) => this.createPageKeyStandardOption((i + 1).toString(), v)));
  }

  private createPageKeyStandardOption(label: string, value: number): StandardOption<number> {
    return { label: label, value: value, description: "", };
  }

  private createUnselectedFirstComboOption(): IComboOption {
    return {
      text: "-- 選択 --",
      isSelected: true,
      score: null,
      style: {
        foreground: {
          color: {
            value: "#000000",
          }
        },
        background: {
          isEnable: false,
          color: {
            value: "#ffffff",
          }
        },
      },
      code: null,
      movePageBehavior: {
        pageKey: null,
        isEnable: false,
      },
    };
  }

  changeForegroundColor(value: string) {
    if (value === null) {
      this.optionForegroundColor = "#000000";
    }
  }

  addOption() {
    this.options = this.options.concat({
      text: this.optionText,
      isSelected: false,
      score: this.optionScore,
      style: {
        foreground: {
          color: {
            value: this.optionForegroundColor,
          }
        },
        background: {
          isEnable: this.isOptionBackgroundColorEnable,
          color: {
            value: this.optionBackgroundColor,
          }
        },
      },
      code: this.optionCode,
      movePageBehavior: {
        pageKey: this.optionPageKey,
        isEnable: !!this.optionPageKey,
      },
    });
  }

  updateOption() {
    this.selectedOptions[0].text = this.optionText;
    this.selectedOptions[0].style.foreground.color.value = this.optionForegroundColor;
    this.selectedOptions[0].style.background.isEnable = this.isOptionBackgroundColorEnable;
    this.selectedOptions[0].style.background.color.value = this.optionBackgroundColor;
    this.selectedOptions[0].score = this.optionScore;
    this.selectedOptions[0].movePageBehavior.pageKey = this.optionPageKey;
    this.selectedOptions[0].movePageBehavior.isEnable = !!this.optionPageKey;
    this.selectedOptions[0].code = this.optionCode;
  }

  moveOptions(offset: number) {
    const indexes = this.selectedOptions.map(v => this.options.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.options[index];
    this.options.splice(index, 1);
    this.options.splice(index + offset, 0, item);
  }

  removeOptions() {
    this.options = this.options.filter((v) => !this.selectedOptions.some(s => s === v));
  }

  changeOptions(value: IComboOption[]) {
    this.selectedOptions = value;
    if (value.length === 1) {
      const option = ObjectUtility.copyDeeply(value[0]) as IComboOption;
      this.optionText = option.text;
      this.optionForegroundColor = option.style.foreground.color.value;
      this.isOptionBackgroundColorEnable = option.style.background.isEnable;
      this.optionBackgroundColor = option.style.background.color.value;
      this.optionScore = option.score;
      this.optionPageKey = option.movePageBehavior.pageKey;
      this.optionCode = option.code;
    }
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
